/** @format */

import { Badge, IconButton, SvgIcon, Tooltip } from '@mui/material';
import ZapCircleIcon from '@untitled-ui/icons-react/build/esm/ZapCircle';
import { includes, reduce, size } from 'lodash';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyGetBookingRequestByUserQuery } from 'src/api/booking-request-api';
import { useAuth } from 'src/hooks/use-auth';
import { useServerError } from 'src/hooks/use-server-error';
import { useRealtimeStyles } from 'src/hooks/use-style-effect_realitme';
import { ModelConfirmClientActive } from 'src/sections/notification/push-notification';
import { selectClientActiveInteract } from 'src/store/app-slice';
import { BookingNoticePopover } from './booking-notice-popover';
import { selectBookingNoticepPopoverOpen, selectBookingNoticeRequests, setOpenBookingRequestPopover } from './booking-notice.slice';

const splitDataByUserId = (data, userId) => {
  return reduce(
    data,
    (result, item) => {
      const accepted = item.accepted ?? [];
      if (includes(accepted, userId)) {
        result.dataAccepted.push(item);
      } else {
        result.dataNew.push(item);
      }

      return result;
    },
    { dataAccepted: [], dataNew: [] }
  );
};

export const BookingNoticeButton = () => {
  const {
    user: { id }
  } = useAuth();
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const { processError } = useServerError();
  const isActiveInteract = useSelector(selectClientActiveInteract);

  const popoverOpen = useSelector(selectBookingNoticepPopoverOpen);
  const { isSuccess, data } = useSelector(selectBookingNoticeRequests);
  const [getBookingRequest] = useLazyGetBookingRequestByUserQuery();

  const handleOpenPopover = useCallback(() => {
    dispatch(setOpenBookingRequestPopover(true));
  }, []);
  const handleClosePopopver = useCallback(() => {
    dispatch(setOpenBookingRequestPopover(false));
  }, []);

  useEffect(() => {
    getBookingRequest({ id, order: { updatedAt: 'desc' } })
      .unwrap()
      .then(() => {
        // toast.success(`getBookingRequest`);
      })
      .catch((error) => {
        processError(error);
      });
  }, [id]);

  const count = size(data);

  const requests = splitDataByUserId(data, id);

  return (
    <>
      <Tooltip title="Thông báo">
        <IconButton
          ref={anchorRef}
          onClick={handleOpenPopover}
          // sx={{ ...useRealtimeStyles('booking_notice_button', 'success') }}
        >
          <Badge color="error" badgeContent={count}>
            <SvgIcon
              sx={{
                borderRadius: '50%',
                ...(popoverOpen && { color: 'primary.main', transform: 'rotate(260deg)' }),
                ...(isActiveInteract &&
                  useRealtimeStyles({ key: 'booking_notice_button', color: 'secondary', alphaVal: 0.7, border: { left: 4 } }))
              }}
            >
              <ZapCircleIcon
                sx={{
                  cursor: 'pointer'
                  // Xoay 90 độ theo chiều kim đồng hồ
                }}
              />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      {isSuccess && (
        <BookingNoticePopover anchorEl={anchorRef.current} requests={requests} onClose={handleClosePopopver} open={popoverOpen} />
      )}
      <ModelConfirmClientActive />
    </>
  );
};
